import React from 'react';
import { useSelector } from 'react-redux';
import BannerTopComponent from '../bannerTopComponent/BannerTopComponent';

const FinalBannerAfterUnidentified = () => {

  const { texts } = useSelector((state) => state.translate);

  return (
    <BannerTopComponent title={texts.finalBannerTitle} >
    </BannerTopComponent>
  );
}

export default FinalBannerAfterUnidentified;

export const FinalBannerAfterUnidentifiedCharedi = () => {
  const { texts } = useSelector((state) => state.translate);

  return (
    <BannerTopComponent title={texts.finalBannerTitleCharedi} >
    </BannerTopComponent>
  );
}
